// src/modules/registry.js
// Registry modules côté frontend (sidebar + settings)

export const MODULES = [
  {
    key: 'analytics',
    label: 'Analytics',
    category: 'pilotage',
    route: '/analytics',
    roles: ['admin', 'superadmin', 'bi'],
    priority: 'primary',
  },
  {
    key: 'sales',
    label: 'Ventes',
    category: 'ventes',
    route: '/sales',
    roles: ['sales', 'admin', 'superadmin'],
    priority: 'primary',
  },
  {
    key: 'orders',
    label: 'Historique des ventes',
    category: 'ventes',
    route: '/orders',
    roles: ['sales', 'ops', 'admin', 'auditor', 'superadmin'],
    priority: 'primary',
  },
  {
    key: 'customers',
    label: 'Clients',
    category: 'ventes',
    route: '/customers',
    roles: ['sales', 'ops', 'admin', 'auditor', 'superadmin'],
    priority: 'primary',
  },
  {
    key: 'products',
    label: 'Produits & Stock',
    category: 'ops',
    route: '/products',
    roles: ['ops', 'admin', 'superadmin'],
    priority: 'primary',
  },
  {
    key: 'purchases',
    label: 'Achats',
    category: 'ops',
    route: '/purchases',
    roles: ['ops', 'admin', 'superadmin'],
    priority: 'secondary',
  },
  {
    key: 'expenses',
    label: 'Dépenses',
    category: 'ops',
    route: '/expenses',
    roles: ['ops', 'admin', 'superadmin'],
    priority: 'secondary',
  },
  {
    key: 'prestations',
    label: 'Prestations',
    category: 'ops',
    route: '/prestations',
    roles: ['ops', 'admin', 'superadmin', 'sales'],
    priority: 'secondary',
  },
  {
    key: 'agenda',
    label: 'Agenda',
    category: 'ops',
    route: '/agenda',
    roles: ['ops', 'admin', 'superadmin', 'sales'],
    priority: 'secondary',
  },
  {
    key: 'relances',
    label: 'Communication',
    category: 'ops',
    route: '/communications',
    roles: ['ops', 'admin', 'superadmin'],
    priority: 'secondary',
  },
  {
    key: 'finance',
    label: 'Finance',
    category: 'compta',
    route: '/finance',
    roles: ['superadmin'],
    priority: 'secondary',
  },
  {
    key: 'employees',
    label: 'Employés',
    category: 'rh',
    route: '/employees',
    roles: ['ops', 'admin', 'superadmin'],
    priority: 'secondary',
  },
  {
    key: 'audit',
    label: 'Audit',
    category: 'security',
    route: '/admin/audit',
    roles: ['auditor', 'superadmin'],
    priority: 'secondary',
  },
  {
    key: 'quotes',
    label: 'Devis',
    category: 'ventes',
    route: '/quotes',
    roles: ['sales', 'ops', 'admin', 'superadmin'],
    priority: 'primary',
  },
]

export const MODULES_BY_KEY = MODULES.reduce((acc, m) => {
  acc[m.key] = m
  return acc
}, {})

export const CATEGORIES = [
  { key: 'pilotage', label: 'Pilotage' },
  { key: 'ventes', label: 'Ventes' },
  { key: 'ops', label: 'Opérations' },
  { key: 'rh', label: 'RH & Interne' },
  { key: 'compta', label: 'Comptabilité' },
  { key: 'security', label: 'Sécurité' },
  { key: 'admin', label: 'Administration' },
]
